import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { BsX } from 'react-icons/bs';
import { colors } from '../theme/colors';
export function SectionModal(_ref) {
  var children = _ref.children;

  var _useState = useState(true),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  return /*#__PURE__*/_jsxs(Box, {
    as: "section",
    w: "full",
    bgColor: colors.sectionBackground,
    "data-testid": "rating",
    position: "relative",
    p: "4",
    mb: "2",
    display: isOpen ? 'block' : 'none',
    children: [/*#__PURE__*/_jsx(Button, {
      color: "gray.600",
      fontSize: "xl",
      focusOutline: "none",
      bg: "transparent",
      position: "absolute",
      top: "0",
      right: "0",
      _hover: {
        color: "gray.700",
        background: "transparent",
        outline: "none"
      },
      onClick: function onClick() {
        return setIsOpen(false);
      },
      children: /*#__PURE__*/_jsx(BsX, {})
    }), children]
  });
}